import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const createJobDescription = createAsyncThunk("createJobDescription", async (payload, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`/jdoc/createjdesc`, payload);
		return response?.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Something went wrong");
	}
});

const JobDescriptionCreateSlice = createSlice({
	name: "JobDescriptionCreateSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		successMessage: null,
	},
	reducers: {
		resetJobDescriptionCreate: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
			state.successMessage = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(createJobDescription.pending, (state) => {
			state.isLoading = true;
			state.error = null;
			state.successMessage = null;
		});
		builder.addCase(createJobDescription.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
			// attempt common API shapes
			state.successMessage = action?.payload?.message || "Created successfully";
		});
		builder.addCase(createJobDescription.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.successMessage = null;
		});
	},
});

export const { resetJobDescriptionCreate } = JobDescriptionCreateSlice.actions;
export default JobDescriptionCreateSlice.reducer;
